<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.112.112h19.776v19.776H.112V.112z" />
    <path
      d="M9.68317 2.4843C9.60396 2.57399 9.41584 2.86995 9.26733 3.13901C8.78218 4.0269 8.82178 4.00897 7.19802 4.3139C3.07921 5.07623 0.584161 6.20628 0.594062 7.30942C0.603963 7.74888 0.920794 8.26906 1.46535 8.70852C1.9901 9.13901 3.33663 9.83856 3.44555 9.73094C3.47525 9.70404 3.30693 9.51569 3.04951 9.32735C2.43565 8.84305 1.9802 8.20628 1.9802 7.82063C1.9802 7.14798 3.0198 6.65471 5.26733 6.24215C6.9703 5.92825 7.0495 5.91928 6.9901 6.05381C6.9703 6.11659 6.73267 6.4574 6.47525 6.82511C5.36634 8.38565 4.16832 10.7623 3.77228 12.1525C3.30693 13.8117 3.30693 15.426 3.77228 16.5471C3.9703 17.0404 4.45545 17.5785 4.70297 17.5785C5 17.5785 5.05941 17.3184 5.08911 15.7668C5.10891 14.3946 5.14852 14.1256 5.37624 13.4081C5.69307 12.4395 6.9802 10.0807 8.59406 7.53363L9.75247 5.69507L10.4158 5.63229C10.7822 5.58744 12.0297 5.53363 13.1881 5.48879L15.297 5.41704L15.9208 5.11211C16.6436 4.7713 17.2475 4.18834 17.5842 3.5426C18.0099 2.73542 17.8614 2.52018 17.0891 2.82511C16.1287 3.20179 14.0297 3.5426 11.5644 3.72197L10.6931 3.78475V3.33632C10.6931 2.95067 10.6436 2.84305 10.3861 2.60986C10.0396 2.29596 9.89109 2.26906 9.68317 2.4843Z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
